import React, { useState } from "react";
import {
  Row,
  Col,
  Button,
  Dropdown,
  Modal,
  Form,
  Breadcrumb,
} from "react-bootstrap";
import { FiHome, FiUpload, FiPlus, FiChevronUp } from "react-icons/fi";
import EscalationRulesList from "../../../components/super-admin/Subscription/Tickets/EscalationRulesList";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";

const EscalationsRulesPage = ({ openModal }) => {
  const [addRules, setAddRule] = useState(false);
  const [rules, setRules] = useState([
    {
      id: "#ER005",
      trigger: "SLA Breach",
      priority: "Critical",
      condition: "No resolution",
      level: "Level 1",
      escalate: "Team Lead",
      time: "30 mins",
      action: "Notify",
    },
    {
      id: "#ER004",
      trigger: "SLA Breach",
      priority: "High",
      condition: "No resolution",
      level: "Level 1",
      escalate: "Support Lead",
      time: "1 hour",
      action: "Notify + Assign",
    },
    {
      id: "#ER009",
      trigger: "SLA Based",
      priority: "Critical",
      condition: "No resolution",
      level: "Level 2",
      escalate: "Web Devloper",
      time: "30 mins",
      action: "Remainder",
    },
    {
      id: "#ER007",
      trigger: "SLA Based",
      priority: "High",
      condition: "No resolution",
      level: "Level 1",
      escalate: "Cyber Expert",
      time: "1 hour",
      action: "Notify ",
    },
    {
      id: "#ER009",
      trigger: "SLA Based",
      priority: "Critical",
      condition: "No resolution",
      level: "Level 2",
      escalate: "Web Devloper",
      time: "30 mins",
      action: "Remainder",
    },
    {
      id: "#ER007",
      trigger: "SLA Breach",
      priority: "High",
      condition: "No resolution",
      level: "Level 1",
      escalate: "Data Analyist",
      time: "2 hour",
      action: "Notify + Assign",
    },
  ]);

  const [form, setForm] = useState({
    trigger: "",
    level: "",
    time: "",
    escalate: "",
    notify: "",
    notes: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    const newRule = {
      id: `#ER00${rules.length + 1}`,
      trigger: form.trigger,
      priority: "Medium",
      condition: form.notes || "Custom Rule",
      level: form.level,
      escalate: form.escalate,
      time: form.time,
      action: form.notify,
    };

    setRules([...rules, newRule]);

    setAddRule(false);

    setForm({
      trigger: "",
      level: "",
      time: "",
      escalate: "",
      notify: "",
      notes: "",
    });
  };
  return (
    <div style={{ padding: "20px", background: "#f8f9fa", height: "100vh" }}>
      <Row className="align-items-center justify-content-between mb-3">
        {/* <Col md={6}>
          <h3 className="mb-1 fw-bold">Escalation Rules</h3>

          <div className="d-flex align-items-center text-muted">
            <FiHome size={16} />
            <span className="mx-2">Tickets</span>
            <span>Escalation Rules</span>
          </div>
        </Col> */}
        <Col md={6} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
              Escalation Rules
            </h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
                    
                  }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Tickets
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Escalation Rules</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>

        <Col md={6} className="text-md-end mt-2 mt-md-0">
          <Dropdown className="d-inline me-2">
            <Dropdown.Toggle className="border " variant="light">
              <FiUpload className="me-1" />
              Export
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item>Export as PDF</Dropdown.Item>
              <Dropdown.Item>Export as Excel</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Button
            style={{ background: "#ed6402", border: "none" }}
            className="me-2"
            onClick={() => setAddRule(true)}
          >
            <FiPlus className="me-2" />
            Add New Rule
          </Button>

          <Button variant="light">
            <FiChevronUp />
          </Button>
        </Col>
      </Row>
      <EscalationRulesList
        addRules={addRules}
        rules={rules}
        setRules={setRules}
      />
      <Modal show={addRules} onHide={() => setAddRule(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Rule</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Trigger Type</Form.Label>
              <Form.Select name="trigger" onChange={handleChange}>
                <option>Select</option>
                <option>SLA Breach</option>
                <option>Status Based</option>
                <option>Priority Based</option>
                <option>Time Based</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Escalation Level</Form.Label>
              <Form.Select name="level" onChange={handleChange}>
                <option>Select</option>
                <option>Level 1</option>
                <option>Level 2</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Time Threshold</Form.Label>
              <Form.Select name="time" onChange={handleChange}>
                <option>Select</option>
                <option>30 mins</option>
                <option>1 hour</option>
                <option>4 hours</option>
                <option>6 hours</option>
                <option>8 hours</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Escalate To</Form.Label>
              <Form.Select name="escalate" onChange={handleChange}>
                <option>Select</option>
                <option>Team Lead</option>
                <option>Support Lead</option>
                <option>Supervisor</option>
                <option>Admin</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Notify By</Form.Label>
              <Form.Select name="notify" onChange={handleChange}>
                <option>Select</option>
                <option>Notify</option>
                <option>Notify + Assign</option>
                <option>Reminder</option>
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="notes"
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setAddRule(false)}>
            Cancel
          </Button>

          <Button
            style={{ background: "#ff6a00", border: "none" }}
            onClick={handleSave}
          >
            Add Rule
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EscalationsRulesPage;
